<template>
  <div class="all">
    <el-row type="flex" class="row-bg">
      <el-col :span="1"></el-col>
      <el-col :span="4" class="el-head">
        <div class="headleft">
          <img src="../../assets/image/home/logo.png" height="35" />
        </div>
      </el-col>
      <el-col :span="14">
        <div class="mid">
          <el-menu
            :default-active="curActive"
            class="el-menu-demo"
            mode="horizontal"
            background-color="#FFF"
            text-color="#666"
            :router="true"
            active-text-color="#FF462A"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <!-- <el-menu-item index="/Traincourse">培训课程</el-menu-item> -->

            <el-submenu
              index="2"
              :default-active="curActive"
              class="navbar"
              mode="horizontal"
              :router="true"
            >
              <template slot="title">培训课程</template>
              <el-menu-item index="/Traincourse">培训课程</el-menu-item>

              <!-- <div v-for="(item, i) in list" :key="i">
                <el-menu-item :index="'/Traincourse/' + item.id">{{
                  item.title
                }}</el-menu-item>
              </div> -->
            </el-submenu>
            <el-menu-item index="/guide">考试指南</el-menu-item>
            <!-- <el-submenu
              index="3"
              :default-active="curActive"
              class="navbar"
              mode="horizontal"
              :router="true"
            >
              <template slot="title">在线评测</template>
            </el-submenu> -->
            <el-menu-item index="/examination">参加考试</el-menu-item>
            <el-menu-item index="/certInfo">证书发放</el-menu-item>
            <!-- <el-submenu index="4">
              <template slot="title">证书发放</template>
              <el-menu-item index="/certinfo">证书介绍</el-menu-item>
            </el-submenu> -->
          </el-menu>
        </div>
      </el-col>
      <el-col :span="4">
        <div v-if="login" class="headright">
          <span class="user"><i class="el-icon-user"></i> {{ user.name }}</span>
          <span
            @click="link('UserInfo', 'info')"
            style="color:#ff462a"
            class="usercenter"
            >个人中心 <i class="el-icon-arrow-right"></i
          ></span>
        </div>
        <div class="headright" v-else>
          <div class="right" @click="link('Login')">登录</div>
          <button class="reg" @click="link('Regist')">
            立 即 注 册
          </button>
        </div>
      </el-col>
      <el-col :span="1">
        <div></div>
      </el-col>
    </el-row>
    <div class="main">
      <router-view></router-view>
    </div>
    <div class="footer">
      <el-row>
        <el-col :span="4" :offset="5">
          <br />
          <img
            src="../../assets/image/home/logo_w.png"
            alt=""
            style="width:70%"
          />
        </el-col>
        <el-col :span="3">
          <b class="footer_title">项目介绍</b>
          <p>项目介绍</p>
        </el-col>
        <el-col :span="3">
          <b class="footer_title ">课程师资</b>
          <p class="pointer" @click="toTeam">师资介绍</p>
        </el-col>
        <el-col :span="3">
          <b class="footer_title">认证体系</b>
          <p>培训课程</p>
        </el-col>
        <el-col :span="6">
          <b>联系我们</b>
          <p>客服微信：Netban88</p>
          <p>技术支持：021-61806577-8013</p>
          <p>公司邮箱：office@netban.cn</p>
          <p>办公地址：上海市静安区万荣路1188号A座龙软大厦6楼</p>
        </el-col>
      </el-row>
      <p class="text-center copyright">
        <a href="https://beian.miit.gov.cn" target="_blank">
          <img
            src="../../assets/image/public.png"
            alt=""
            style="width: 15px;vertical-align: -3px;"
          />
          沪ICP备10203489号-60</a
        >

        <a
          href="https://beian.mps.gov.cn/#/query/webSearch?code=31010602007937"
          rel="noreferrer"
          target="_blank"
          style="margin:0 10px"
          >沪公网安备31010602007937</a
        >
        版权所有 上海生涯规划咨询师认证
      </p>
    </div>
  </div>
</template>

<script>
import ImportData from "../../../admin/components/importData.vue";

export default {
  name: "Layout",
  components: { ImportData },
  data() {
    return {
      curActive: "/",
      user: {},
      login: false,
      list: [],
    };
  },
  mounted() {
    this.curActive = this.$route.path;
  },
  created() {
    this.init();
  },
  watch: {
    $route(to) {
      if (to.path == "/") {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.user = this.$store.state.wps_user || null;
      this.login = this.$store.state.wps_user.mobile ? true : false;
      let _this = this;
      _this.$http
        .post(process.env.VUE_APP_URL + "article/navClist")
        .then((data) => {
          if (data.data.code == 200) {
            this.list = data.data.data;
            this.list.forEach((e, i) => {});
            return;
          }
          {
            _this.$message.error(data.data.msg);
            return;
          }
        })
        .catch(function(error) {
          _this.$message.error("网络错误，请刷新界面重试");
          return;
        });
    },
    link(name, id) {
      if (id) {
        this.$router.push({ name: name, params: { id: id } });
      } else {
        this.$router.push({ name: name });
      }
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
    toTeam() {
      this.$router.push({ name: "Team" });
    },
  },
};
</script>
<style lang="less" scoped>
.pointer {
  cursor: pointer;
}

.all {
  width: 100%;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.row-bg {
  background-color: #fff;
  width: 100%;
}

.el-head {
  display: flex;
  justify-content: center;
  align-items: center;
}

.headleft {
  width: 200px;
}

.el-menu-item {
  padding: 0 17px;
}

.mid {
  height: 60px;
  display: flex;
  justify-content: center;
}

.headright {
  height: 60px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.headright span {
  cursor: pointer;
}

.right {
  height: 30px;
  margin-right: 20px;
  color: #ff462a;
  font-size: 16px;
  line-height: 30px;
  cursor: pointer;
}

.reg {
  color: #fff;
  background: #ff462a;
  width: 100px;
  height: 25px;
  border: #ffffff;
  font-size: 15px;
  cursor: pointer;
}

.footer {
  width: 100%;
  background-color: #2b2b2b;
  line-height: 20px;
  color: #fff;
  padding: 20px 0;

  p {
    font-size: 12px;
    padding: 0;
    margin: 0;
  }

  b {
    display: inline-block;
    font-size: 14px;
    margin-bottom: 20px;
    padding-bottom: 5px;
  }
}

.user {
  margin-right: 15px;
}

.copyright {
  font-size: 14px !important;
  padding: 20px 0 !important;

  a {
    color: #fff;
  }
}

.footer_title {
  border-bottom: 3px solid #8e1023;
}

@media screen and (max-width: 768px) {
  .el-menu-item {
    padding: 0 8px;
  }

  /deep/.el-submenu__title {
    padding: 0 5px;
    background-color: #fb5227;
    // border-bottom-color:#FFFFFF;
    // color:#FFFFFF;
    font-weight: 500;
  }

  .user {
    color: #fff;
    font-size: 8px;
    margin-right: 10px;
    cursor: pointer;
  }

  .usercenter {
    font-size: 10px;
    cursor: pointer;
    color: #ff462a;
  }

  .headleft {
    width: 150px;
  }

  .headlefticon {
    height: 20px;
  }
}
</style>
